module.exports = __webpack_public_path__ + "static/media/icon-train.4ae825eb.svg";